import styled from "styled-components";
import {useSelector} from "react-redux";
import {GET_USER_ALERT} from "@/store/slices/userSlice";
import themes from "@/styles/themes";

const Alert = styled.div`
  padding: 10px 20px;
  font-size: 12px;
  display: none;

  &.visible {
    display: block;
  }

  &.success {
    color: white;
    border-radius: 4px;
    background: ${themes.green};
    border: 1px solid ${themes.green};
  }

  &.error {
    color: white;
    border-radius: 4px;
    background: ${themes.red};
    border: 1px solid ${themes.red};
  }
`
export default function UserAlert() {
    const alert = useSelector(GET_USER_ALERT)
    return (
        <Alert className={(alert.show) ? `visible ${alert.type}` : ``}>
            <p>{alert.message}</p>
        </Alert>
    )
}